
import Vue from 'vue';
import AudioPlayer from '@media/components/audio/AudioPlayer.vue';

type widgetType = 'widget' | 'lead';
interface Props {
  content: {
    attrs: any;
  };
  type: widgetType;
}

interface Computed {
  getKeywords: string[];
  adFree: boolean;
  ads: {
    adFree: boolean;
    keywords: string[];
  };
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    AudioPlayer,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    type: {
      type: String as () => widgetType,
      required: false,
      default: 'widget',
    },
  },
  computed: {
    getKeywords() {
      return this.$store.getters['adForm/getAdsKeywords'];
    },
    adFree() {
      return this.$store.state.piano.access.adFree || false;
    },
    ads() {
      return {
        adFree: this.adFree,
        keywords: this.getKeywords,
      };
    },
  },
});
